import { MctPlanTypeCoverageSelector } from "../../app/contexts/Analytics/types";
import { CoverageType } from "./types";

export const choiceIdMap: Record<CoverageType, string> = {
  [CoverageType.MAPD]: "what-coverage-mapd",
  [CoverageType.PDP]: "what-coverage-pdp",
  [CoverageType.PDPAndMedigap]: "what-coverage-pdp-medigap",
  [CoverageType.MedigapPolicy]: "what-coverage-medigap",
  [CoverageType.learnMore]: "learn-more",
};

export const planTypeGa4EventMap: Record<
  CoverageType,
  MctPlanTypeCoverageSelector
> = {
  [CoverageType.MAPD]: MctPlanTypeCoverageSelector.MAPD,
  [CoverageType.PDP]: MctPlanTypeCoverageSelector.PDP,
  [CoverageType.PDPAndMedigap]: MctPlanTypeCoverageSelector.PDPAndMedigap,
  [CoverageType.MedigapPolicy]: MctPlanTypeCoverageSelector.MedigapPolicy,
  [CoverageType.learnMore]: MctPlanTypeCoverageSelector.learnMore,
};
